<template>
  <center>
    <h1>404!! Page Not Found!</h1>
    <p>
      <a href="/">Go home?</a>
    </p>
  </center>
</template>

<script>
export default {
  name: "PageNotFound",
  data() {
    return {};
  },
};
</script>

<style scoped>
center {
  margin: 15vw;
}

h1 {
  color:blanchedalmond;
  font-size: 2em;
}
</style>